export const MenuList = [
  { title: 'home', url: '/' },
  { title: 'about', url: '/about' },
  { title: 'skills', url: '/skills' },
  { title: 'work', url: '/work' },
  { title: 'contacts', url: '/contacts' },
];
